<template>
  <StationSelectModal
    ref="stationSelectRef"
    :display-id="DISPLAY_ID"
    title="作業駅選択"
    :hide-cancel="logic.hideCancel.value"
    :show-frequent-stations="logic.showFrequentStations.value"
    @station-selected="updateWorkingStation"
    @canceled="logic.handleCanceled"
  />
</template>

<script setup lang="ts">
import StationSelectModal from './StationSelectModal.vue';
import type { StationWithOrganization } from '~/types/common/stationWithOrganization';
import { useOperationStationModalLogic } from '~/composables/modal/useOperationStationModalLogic';

const DISPLAY_ID = 'C-02';

const stationSelectRef = ref<InstanceType<typeof StationSelectModal>>();

// composableからロジックを使用
const logic = useOperationStationModalLogic(DISPLAY_ID);

// 選択した駅情報を親コンポーネントに通知するためのイベント
const emit = defineEmits<{
  completed: [];
  canceled: [];
}>();

// composableのコールバックを設定
logic.setCompletedCallback(() => {
  emit('completed');
});

logic.setCanceledCallback(() => {
  emit('canceled');
});

/**
 * 選択された情報で作業駅を更新する
 */
const updateWorkingStation = async (selectedStation: StationWithOrganization) => {
  await logic.updateWorkingStation(selectedStation);
};

/**
 * モーダルを開く
 */
const open = async () => {
  if (stationSelectRef.value) {
    await stationSelectRef.value.openModal();
  }
};

/**
 * モーダルを閉じる
 */
const close = () => {
  if (stationSelectRef.value) {
    stationSelectRef.value.closeModal();
  }
};

defineExpose({
  open,
  close,
});
</script>

<style lang="scss" scoped>
label {
  font-size: 20px;
  font-weight: bold;
}
</style>
